import { ArtworkDetailsColumn } from "../ArtworkDetailsColumn";
import { FC } from "react";
import { getSalePrice, ISale, isInstantSale } from "state/sales";
import { Person } from "components/Person";
import { SolUsdDisplay } from "components/SolUsdDisplay";
import { truncateInMiddle } from "utils/truncateInMiddle";
import { useCustomBreakpoints } from "hooks/useCustomBreakpoints";
import { SupplyDetails } from "./SupplyDetails";

interface Props {
  sale?: ISale;
}

export const SecondarySaleDetails: FC<Props> = ({ sale }) => {
  const { xlUp, xxlUp } = useCustomBreakpoints();

  if (!sale) return null;

  const resaleBy = isInstantSale(sale)
    ? truncateInMiddle(sale.refs.seller)
    : "-";

  return (
    <>
      {xxlUp && (
        <ArtworkDetailsColumn title="Resale by">
          <Person address={resaleBy} />
        </ArtworkDetailsColumn>
      )}

      {xlUp && (
        <ArtworkDetailsColumn title="Current sold">
          <SolUsdDisplay sol={getSalePrice(sale) || 0} />
        </ArtworkDetailsColumn>
      )}

      <ArtworkDetailsColumn title="Supply">
        <SupplyDetails {...sale.artwork.prints} />
      </ArtworkDetailsColumn>
    </>
  );
};
